import { nanoid } from 'nanoid'
import _ from 'lodash'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { t } from 'i18next'
import { RightIcon } from 'assets/icons'
import { Tooltip } from 'antd';

// 查找 url search 参数
export const getHashSearchParam = key => {
    const url = window.location.search
    // 获取 hash 值，不包含 '#' 号
    // const hash = url.substring(url.indexOf('#') + 1)
    // // 查找 '?' 号所在的索引
    // const searchIndex = hash.indexOf('?')
    // // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
    // const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : ''
    // 把搜索参数字符串提过URLSearchParams转成对象形式
    const usp = new URLSearchParams(url.slice(1))
    // 通过URLSearchParams自带的get方法，查询键所对应的值
    return usp.get(key)
}

// echarts 主状图，数据视图自定义表格样式
export const echartsBarDataViewTableHtml = opt => {
    const dataset = opt.dataset[0]
    let tableTop = `<table style="text-align:right" class="echartsBarDataViewTableHtml"><tbody>`
    let tableLast = `</tbody></table>`
    let tableHeader = `<tr class="tHeader">${dataset.dimensions.map(item => `<th>${item}</th>`).join(' ')}</tr>`
    let tableBody = dataset.source
        .map(
            p => `<tr class="tBody">${dataset.dimensions.map(arr => `<td>${p[arr] ? p[arr] : 0}</td>`).join(' ')}</tr>`
        ) // 前端的数据为空时补零
        .join(' ')
    let tableHtml = tableTop + tableHeader + tableBody + tableLast
    return tableHtml
}

// echarts 柱状图/折线图合并，数据视图自定义表格样式
export const echartsBarLineDataViewTableHtml = (summary, summaryDimensions1) => {

    let dimensions = summaryDimensions1?.filter(item => item !== 'Date')
    let source = summary

    // 合并两个数组
    const combinedDimensions = ['Date', 'Total', ...dimensions?.filter(item => item !== 'Total')];
    const combinedSource = [...source]
    let tableTop = `<table style="text-align:right" class="echartsBarDataViewTableHtml"><tbody>`
    let tableLast = `</tbody></table>`
    let tableHeader = `<tr class="tHeader">${combinedDimensions.map(item => `<th>${item}</th>`).join(' ')}</tr>`
    let tableBody = combinedSource
        .map(
            p => `<tr class="tBody">${combinedDimensions.map(arr => `<td>${p[arr] ? p[arr] : 0}</td>`).join(' ')}</tr>`
        ) // 前端的数据为空时补零
        .join(' ')
    let tableHtml = tableTop + tableHeader + tableBody + tableLast
    return tableHtml
}

// echarts 饼图，数据视图自定义表格样式
export const echartsPieDataViewTableHtml = opt => {
    const data = opt.series[0].data
    let tableTop = `<table style="text-align:right" class="echartsBarDataViewTableHtml"><tbody>`
    let tableLast = `</tbody></table>`
    let tableBody = data.map(p => `<tr class="tBody">${`<td>${p.name}</td><td>${p.value}</td>`}</tr>`).join(' ')
    let tableHtml = tableTop + tableBody + tableLast
    return tableHtml
}

// echarts 折现图，数据视图自定义表格样式
export const echartsLineDataViewTableHtml = opt => {
    const dataset = opt.dataset[0];
    const { dimensions, source } = dataset;

    if (!dimensions || !source) {
        return '<table class="echartsBarDataViewTableHtml"><tbody></tbody></table>';
    }

    // 构建表头
    let tableHtml = `<table style="text-align:right" class="echartsBarDataViewTableHtml"><thead><tr>`;
    dimensions.forEach(dim => {
        tableHtml += `<th>${dim}</th>`;
    });
    tableHtml += `</tr></tHead><tbody>`;

    // 构建表体
    source.forEach(row => {
        tableHtml += '<tr class="tBody">';
        if (Array.isArray(row)) {
            dimensions.forEach((dim, index) => {
                tableHtml += `<td>${row[index] ?? ''}</td>`;
            });
        } else {
            dimensions.forEach(dim => {
                tableHtml += `<td>${row[dim] ?? ''}</td>`;
            });
        }
        tableHtml += '</tr>';
    });

    tableHtml += `</tbody></table>`;
    return tableHtml;
};

// 切换主题
export const theme = type => window.document.documentElement.setAttribute('data-theme', type)

// 存储 localStroage
export const setStroage = (key, type) => window.localStorage.setItem(key, type)

// 读取 localStroage
export const getStroage = key => window.localStorage.getItem(key)

// 清除 localStroage
export const clearStroage = account => {
    if (account) return window.localStorage.removeItem('account')
    const accountBackup = window.localStorage.getItem('account')
    const languageBackup = window.localStorage.getItem('language')
    window.localStorage.clear()
    window.localStorage.setItem('account', accountBackup)
    window.localStorage.setItem('language', languageBackup)
}

// 函数防抖 debounce：delay 时间内只执行一次
export const debounce = (fun, delay = 200) => {
    let timeBar = null
    return (...arg) => {
        if (timeBar) {
            clearTimeout(timeBar)
        }
        timeBar = setTimeout(() => {
            fun.apply(this, arg)
        }, delay)
    }
}

// 函数节流 throttle：按 delay 时间来间隔执行
export const throttle = (fun, delay = 300) => {
    let timerBar = null
    return (...arg) => {
        if (timerBar) return
        timerBar = setTimeout(() => {
            fun.apply(this, arg)
            timerBar = null
        }, delay)
    }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function optionsTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children',
    }

    var childrenListMap = {}
    var nodeIds = {}
    var tree = []

    for (let d of data) {
        let parentId = d[config.parentId]
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = []
        }
        nodeIds[d[config.id]] = d
        childrenListMap[parentId].push(d)
    }

    for (let d of data) {
        let parentId = d[config.parentId]
        if (nodeIds[parentId] == null) {
            tree.push(d)
        }
    }

    for (let t = 0; t < tree.length; t++) {
        const o = adaptToChildrenList(tree[t])
        tree[t] = o
    }

    function adaptToChildrenList(o) {
        const p = { ...o }
        if (childrenListMap[o[config.id]] !== null) {
            p.children = childrenListMap[o[config.id]]
            o = { ...p }
        }
        if (o['children']) {
            for (let c = 0; c < o['children'].length; c++) {
                const b = adaptToChildrenList(o['children'][c])
                o['children'][c] = b
            }
        }
        return o
    }
    return tree
}

// 获取日历相关参数
export const getCalendarParams = (viewType, paramsObj) => {
    let params
    switch (viewType) {
        case 'dayGridMonth': // 月 - 日历
            params = {
                ...paramsObj,
                dateType: 'day',
            }
            break
        default:
    }
    return params
}

/* 
填充日历事件数据对象，返回自定义的 dom 结构
    参数 argObj 为[事件对象]与[一些信息]集合对象 
    参数 calendarData 为日历上的接口数据
    参数 paramsList 为日历上的事件数据配置 
*/
export const renderEventContent = (argObj, calendarData, eventList, dailyState) => {
    let result = [] // 必须为数组
    calendarData?.forEach(item => {
        if (item.produceDate === argObj.event.startStr) {
            let count = 0
            if (window.location.pathname === '/activity_diary') {
                // 更改activity diary日历界面的显示内容
                let resultStr = ''
                let arr = []
                // if (item.acquisitionSummary) {
                //     arr.push(item.acquisitionSummary)
                // }
                if (item.operationSummary) {
                    arr.push(item.operationSummary)
                }
                if (item.nextHour) {
                    arr.push(item.nextHour)
                }
                if (item.comment) {
                    arr.push(item.comment)
                }
                arr.forEach(str => {
                    resultStr += str + '\n'
                })
                resultStr = resultStr.substring(0, resultStr.lastIndexOf('\n'))
                const parser = new DOMParser();
                const doc = parser.parseFromString(resultStr, 'text/html');
                const textContent = doc.body.textContent || ""; // 兼容旧版浏览器  
                result.push(
                    <Tooltip title={textContent} key={nanoid()}>
                        <div className='commontEvent'>{textContent}</div>
                    </Tooltip>
                )
            } else if (window.location.pathname === '/project_summary') {
                // 更改project_summary日历界面的显示内容
                let resultStr = ''
                let arr = []
                if (item.operationSummary) {
                    arr.push(item.operationSummary)
                }
                arr.forEach(str => {
                    resultStr += str + '\n'
                })
                resultStr = resultStr.substring(0, resultStr.lastIndexOf('\n'))
                const parser = new DOMParser();
                const doc = parser.parseFromString(resultStr, 'text/html');
                const textContent = doc.body.textContent || ""; // 兼容旧版浏览器  
                result.push(
                    <Tooltip title={textContent} key={nanoid()}>
                        <div className='commontEvent'>{textContent}</div>
                    </Tooltip>
                )
            } else {
                if (item.comment !== '') {
                    result.push(
                        <Tooltip title={item.comment} key={nanoid()}>
                            <div className='commontEvent'>{item.comment}</div>
                        </Tooltip>
                    )
                }
            }
            eventList?.forEach(p => {
                if (item[p.name] > 0) {
                    result.push(
                        <div
                            className='sumEvent'
                            key={nanoid()}
                            style={{ left: 9 * (count * 3 + 1) + 'px', color: p.color, backgroundColor: p.bgc }}
                        >
                            {item[p.name]}
                        </div>
                    )
                    count += 1
                }
            })
        }
    })
    const currentDate = argObj.event.startStr
    if (dailyState?.[currentDate]) result.push(<RightIcon className='trueState' key={nanoid()} />)
    return result
}

// 延迟处理
export const waitTime = (time = 1000) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(true)
        }, time)
    })
}

/* 格式化 select 数据 */
export const formatSelectOptions = (data, name) => {
    if (!data) return []
    return data.map(item => {
        if (name === 'coordinateSystem') {
            return {
                label: item.wkt,
                value: item.code,
            }
        } else {
            return {
                label:
                    (getStroage('language') === 'zh' ? item.dictLabel ?? item.deptName : item.dictLabelEn ?? item.deptNameEn) ??
                    item.name ??
                    item.label ??
                    item.locationName ?? '',
                value: item.dictValue ?? item.id ?? item.value ?? item.locationId ?? item.deptCode ?? '',
            }
        }
    })
}

/* 格式化 RWP 字典数据 */
export const formatRWPOptions = data => {
    if (!data) return {}
    return {
        label: getStroage('language') === 'zh' ? data.dictLabel : data.dictLabelEn,
        value: data.dictValue,
    }
}

/* 将时间换算成秒 */
export const stringTimeToSeconds = timeString => {
    let parts = timeString.split(':')
    let hours = parseInt(parts[0], 10)
    let minutes = parseInt(parts[1], 10)

    return hours * 3600 + minutes * 60
}

/* 格式化表格数据 */
export const formatTableData = (item, projectId) => {
    let result = {
        ...item,
        projectId,
        id: null, // 不需要表格组件自动生产的 id，有值下次提交接口报错：重复 id
    }
    for (let key in item) {
        if (Array.isArray(item[key])) result[key] = item?.[key]?.slice(-1)[0] // 级联，取末尾字符串
    }
    return result
}

/* 格式化表格数据 */
export const formatDrillTableData = (item, projectId, calendarInfo, id, isSave) => {
    let result = {
        ...item,
        projectId,
        id: isSave ? null : typeof item?.id === 'string' ? item.id : null, // 不需要表格组件自动生产的 id，有值下次提交接口报错：重复 id
        saveType: item?.saveType === 'delete' ? 'delete' :  'save',
        produceDate: calendarInfo
    }
    for (let key in item) {
        if (Array.isArray(item[key])) result[key] = item?.[key]?.slice(-1)[0] // 级联，取末尾字符串
    }
    return result
}

/* 格式化项目总结表格数据 */
export const formatProjectSummaryTableData = (item, projectId) => {
    let result = {
        ...item,
        projectId,
        duration: Number(item.duration),
        minuteDiff: Number(item.minuteDiff)
    }
    delete result?.id
    for (let key in item) {
        if (Array.isArray(item[key])) result[key] = item?.[key]?.slice(-1)[0] // 级联，取末尾字符串
    }
    return result
}

/* 分钟转为时间 */
export const formatMinute = interval => {
    let hour = parseInt(interval / 60)
    if (interval / 60 < 0 && interval / 60 > -1) hour = '-' + hour

    let minute = Math.abs(interval % 60)
    if (minute === 0) minute = '00'
    if (minute < 10 && minute > 0) minute = '0' + minute
    if (isNaN(hour) || isNaN(minute)) return false

    return `${hour}:${minute}`
}

/* 将 undefined 转为 空字符串 */
export const formatParams = obj => {
    let result = { ...obj }
    const arr = Object.keys(result)
    arr.forEach(key => {
        if (result[key] === undefined) {
            result[key] = ''
        }
    })
    return result
}

/**
 * 对象数组去重
 * @ arr  需要去重的数组
 * @ flag 按该字段去重
 */
export const unique = (arr, flag) => {
    let hash = {}
    return arr.reduce((pre, cur) => {
        if (hash[cur[flag]]) {
        } else {
            hash[cur[flag]] = true && pre.push(cur)
        }
        return pre
    }, [])
}

/**
 * 过滤空值
 * @ arr  需要去空值的数组
 * @ flag 按该字段过滤
 */
export const filterNullValue = (arr, flag) => {
    return arr.filter(item => item[flag])
}

/**
 * 格式化过滤数组项
 * @ arr  需要格式的数组
 * @ flag 按该字段格式
 */
export const formateFilterOptions = (arr, flag) => {
    return arr.map(item => ({
        text: item[flag],
        value: item[flag],
    }))
}

/* 级联 td 显示自定义字符串 */
export const getCascadeLable = (value, dictData) => {
    if (!value) return ''
    let parentLabel,
        sonLabel = ''
    const parentValue = value[0]
    const sonValue = value[1]
    for (let i = 0; i < dictData[0].data.data.length; i++) {
        const obj = dictData[0].data.data[i]
        if (obj.dictValue === sonValue) {
            sonLabel = getStroage('language') === 'zh' ? obj.dictLabel : obj.dictLabelEn
        }
        if (obj.dictValue === parentValue) {
            parentLabel = getStroage('language') === 'zh' ? obj.dictLabel : obj.dictLabelEn
        }
    }
    return `${parentLabel} / ${sonLabel}`
}

/* 格式化，将 null 转为 undefined */
export const formateNull = data => {
    const a = _.cloneDeep(data)
    a.forEach(list => {
        if (Array.isArray(list)) {
            list.forEach((item, index) => {
                item.countNum = index
                Object.keys(item).forEach(itemSub => {
                    if (item[itemSub] === null) {
                        item[itemSub] = undefined
                    }
                })
            })
        }
    })
    return a
}

// 度°分′秒″ 转十进制
export const ToDigital = (strDu, strFen, strMiao, len, position, position1) => {
    len = len > 6 || typeof len == 'undefined' ? 6 : len //精确到小数点后最多六位
    strDu = typeof strDu == 'undefined' || strDu === '' ? 0 : parseFloat(strDu)
    strFen = typeof strFen == 'undefined' || strFen === '' ? 0 : parseFloat(strFen) / 60
    strMiao = typeof strMiao == 'undefined' || strMiao === '' ? 0 : parseFloat(strMiao) / 3600
    var digital = strDu + strFen + strMiao
    if (position === 'S' || position1 === 'W') {
        return -digital.toFixed(len)
    }
    if (digital === 0) {
        return ''
    } else {
        return digital.toFixed(len)
    }
}
// MMO FLAG 度°分′秒″ 转十进制
export const dmsToDecimal = (coordStr) => {
    const match = coordStr.match(/(North|South|East|West)\s+(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)(?:\s+(\d+(?:\.\d+)?))?/i);
    if (!match) return NaN;

    const dir = match[1];
    const deg = parseFloat(match[2]);
    const min = parseFloat(match[3]);
    const sec = match[4] ? parseFloat(match[4]) : 0;

    let decimal = deg + min / 60 + sec / 3600;
    if (['South', 'West'].includes(dir)) decimal = -decimal;

    return parseFloat(decimal.toFixed(5)); // 保留5位小数并转为数值
}


/**
 * 导出 excel 文件, 依赖 xlsx 库
 * @param sheetData 数组表格数据
 * @param fileName 文件名
 */
export const exportFile = (sheetData, fileName, field, label) => {
    // 将由对象组成的数组转化成sheet
    const sheet = XLSX.utils.json_to_sheet(sheetData, {
        header: field, //通过设置field可以把这个 field 排在前头
    })
    // 找出 这个表格的 单元格 范围
    const range = XLSX.utils.decode_range(sheet['!ref'])

    // 找到worksheet中 A1,B1,C1...等设置表头的字段，替换为上方label对应的数据
    for (let c = range.s.c; c <= range.e.c; c++) {
        const header = XLSX.utils.encode_col(c) + '1'
        sheet[header].v = label[sheet[header].v]
    }

    // 百分数和数字更改为数字类型
    Object.keys(sheet).forEach(key => {
        if (sheet[key].v) {
            const val = sheet[key].v
            if (!isNaN(val)) {
                sheet[key].t = 'n'
            }
            if (val?.lastIndexOf?.('%') === val.length - 1) {
                sheet[key].t = 'n'
                sheet[key].z = '0.00%'
                sheet[key].v = Number(val.substring(0, val.length - 1)) / 100
            }
        }
    })

    // 创建虚拟的workbook
    const wb = XLSX.utils.book_new()

    // 把sheet添加到workbook中
    XLSX.utils.book_append_sheet(wb, sheet, fileName)

    // 创建文件容器 blob
    const workbook2blob = workbook => {
        // 生成excel的配置项
        const wopts = {
            // 要生成的文件类型
            bookType: 'xlsx',
            // // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
            bookSST: false,
            type: 'binary',
        }
        const wbout = XLSX.write(workbook, wopts)
        // 将字符串转ArrayBuffer
        const s2ab = s => {
            const buf = new ArrayBuffer(s.length)
            const view = new Uint8Array(buf)
            for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
            return buf
        }
        const blob = new Blob([s2ab(wbout)], {
            type: 'application/octet-stream',
        })
        return blob
    }
    const workbookBlob = workbook2blob(wb)

    // 触发下载
    const openDownload = (blob, fileName) => {
        if (typeof blob === 'object' && blob instanceof Blob) {
            blob = URL.createObjectURL(blob) // 创建blob地址
        }
        const aLink = document.createElement('a')
        aLink.href = blob
        // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，有时候 file:///模式下不会生效
        aLink.download = fileName || ''
        let event
        if (window.MouseEvent) event = new MouseEvent('click')
        // 主动触发
        aLink.dispatchEvent(event)
    }
    // 将 blob 对象创建 blobUrl，通过 a 标签和 createObjectURL 实现下载功能实现下载
    openDownload(workbookBlob, `${fileName}.xls`)
}

/**
 * [exportsCSV 导出数据到CSV] ---解决大数据下载
 * @param  {Array}  [_headers=[]]   [表头]
 * @param  {Array}  [_body=[]]      [内容]
 * @param  {String} [name='excel'] [文件名]
 * @return {[type]}                 [无]
 */
export const exportsCSV = ({ _headers = [], _body = [], name = 'csv', callback = function () { } }) => {
    // const headers = _headers.join() + '\n' // 格式化表头
    // const body = _body.map(item => {
    //     // 格式化表内容
    //     return Object.values(item).join() + '\n'
    // })
    // const output = headers.concat(body) // 合并

    const output = _body // 使用 Papa 插件

    const BOM = '\uFEFF'

    // 创建一个文件CSV文件
    var blob = new Blob([BOM + output], { type: 'text/csv;charset=UTF-8' })

    // IE
    if (navigator.msSaveOrOpenBlob) {
        // 解决大文件下载失败
        // 保存到本地文件
        navigator.msSaveOrOpenBlob(blob, `${name}.csv`)
    } else {
        let downloadLink = document.createElement('a')
        // 因为url有最大长度限制，encodeURI是会把字符串转化为url，超出限制长度部分数据丢失导致下载失败,
        // 为此采用创建Blob（二进制大对象）的方式来存放缓存数据，具体代码如下:
        downloadLink.setAttribute('href', URL.createObjectURL(blob))
        downloadLink.download = `${name}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }
    callback()
}

/* 导入 excel 文件 */
export const importExcel = file => {
    return new Promise((resolve, reject) => {
        if (file instanceof File) {
            const reader = new FileReader()
            reader.onloadend = progressEvent => {
                const arrayBuffer = reader.result
                const options = { type: 'array' }
                const workbook = XLSX.read(arrayBuffer, options)
                const sheetNames = workbook.SheetNames
                const result = sheetNames.map(sheetName => workbook.Sheets[sheetName])
                resolve(result)
            }
            reader.readAsArrayBuffer(file)
        } else {
            reject(new Error('入参不是 File 类型'))
        }
    })
}

/* 语言变更，获取不同的布局宽度 */
export const getNavWidth = language => {
    switch (language) {
        case 'zh':
            return 215
        default:
            return 231
    }
}

/* 获取日期最大最小值 */
export const getDateRange = project => {
    const projectStartDate = moment(project?.startDate).format('YYYY-MM-DD')
    const acquisitionStartDate = moment(project?.acquisitionStartDate).format('YYYY-MM-DD')
    const receiverStartDate = moment(project?.receiverStartDate).format('YYYY-MM-DD')
    const activityDiaryStartDate = moment(project?.activityDiaryStartDate).format('YYYY-MM-DD')
    const firstReportDate = moment(project?.firstReportDate).format('YYYY-MM-DD')
    const projectEndDate = moment(project?.endDate).format('YYYY-MM-DD')
    const acquisitionEndDate = moment(project?.acquisitionEndDate).format('YYYY-MM-DD')
    const receiverEndDate = moment(project?.receiverEndDate).format('YYYY-MM-DD')
    const activityDiaryEndDate = moment(project?.activityDiaryEndDate).format('YYYY-MM-DD')
    const lastReportDate = moment(project?.lastReportDate).format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')
    let startDate = [
        projectStartDate,
        acquisitionStartDate,
        receiverStartDate,
        activityDiaryStartDate,
        firstReportDate,
    ].reduce((a, b) => (a < b ? a : b))
    if (startDate > today) startDate = today
    let endDate = [projectEndDate, acquisitionEndDate, receiverEndDate, activityDiaryEndDate, lastReportDate].reduce(
        (a, b) => (a > b ? a : b)
    )
    if (endDate > today) endDate = today
    return { startDate, endDate }
}

/* 获取日期最大最小值2 */
export const getDateRange2 = project => {
    const projectStartDate = moment(project?.startDate).format('YYYY-MM-DD')
    const acquisitionStartDate = moment(project?.acquisitionStartDate).format('YYYY-MM-DD')
    const receiverStartDate = moment(project?.receiverStartDate).format('YYYY-MM-DD')
    const projectEndDate = moment(project?.endDate).format('YYYY-MM-DD')
    const acquisitionEndDate = moment(project?.acquisitionEndDate).format('YYYY-MM-DD')
    const receiverEndDate = moment(project?.receiverEndDate).format('YYYY-MM-DD')
    const startDate = [projectStartDate, acquisitionStartDate, receiverStartDate].reduce((a, b) => (a < b ? a : b))
    let endDate = [projectEndDate, acquisitionEndDate, receiverEndDate].reduce((a, b) => (a > b ? a : b))
    return { startDate, endDate }
}

/* 获取项目相关开始结束日期 */
export const getProjectDateRange = (projectData, type) => {
    let endDate, startDate
    switch (type) {
        case 'source':
            endDate = projectData.acquisitionEndDate ?? moment().format('YYYY-MM-DD')
            startDate = projectData.acquisitionStartDate ?? moment().format('YYYY-MM-DD')
            break
        case 'receiver':
            endDate = projectData.receiverEndDate ?? moment().format('YYYY-MM-DD')
            startDate = projectData.receiverStartDate ?? moment().format('YYYY-MM-DD')
            break
        case 'hse':
            endDate = projectData.lastReportDate ?? moment().format('YYYY-MM-DD')
            startDate = projectData.firstReportDate ?? moment().format('YYYY-MM-DD')
            break
        case 'consumable':
            endDate = projectData.lastReportDate ?? moment().format('YYYY-MM-DD')
            startDate = projectData.firstReportDate ?? moment().format('YYYY-MM-DD')
            break
        default:
            endDate = projectData.endDate ?? moment().format('YYYY-MM-DD')
            startDate = projectData.startDate ?? moment().format('YYYY-MM-DD')
            break
    }
    return { startDate, endDate }
}

/* 获取日期范围预设值 */
export const getDateRangePreset = (projectData, type) => {
    const today = moment().format('YYYY-MM-DD')
    let thisWeek, lastWeek, thisMonth, lastMonth, total, startDate, endDate
    if (!projectData) return {}

    const getValue = (startDate, endDate) => {
        // 本周
        const weekdayStart = moment().weekday(0).format('YYYY-MM-DD')
        thisWeek = [
            moment(weekdayStart < startDate ? startDate : weekdayStart),
            moment(today > endDate ? endDate : today),
        ]
        if (weekdayStart > endDate || today < startDate) thisWeek = null

        // 上周
        const weekStartDay = projectData?.weekStart ?? 1

        const lastWeekStart = moment().day(weekStartDay).subtract(7, 'days').format('YYYY-MM-DD')
        const lastWeekEnd = moment(lastWeekStart).add(6, 'days').format('YYYY-MM-DD')
        lastWeek = [
            moment(lastWeekStart < startDate ? startDate : lastWeekStart),
            moment(lastWeekEnd > endDate ? endDate : lastWeekEnd),
        ]
        if (lastWeekStart > endDate || lastWeekEnd < startDate) lastWeek = null
        // 本月
        const thisMonthStart = moment().startOf('month').format('YYYY-MM-DD')
        thisMonth = [
            moment(thisMonthStart < startDate ? startDate : thisMonthStart),
            moment(today > endDate ? endDate : today),
        ]
        if (thisMonthStart > endDate || today < startDate) thisMonth = null
        // 上月
        const lastMonthStart = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
        const lastMonthEnd = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
        lastMonth = [
            moment(lastMonthStart < startDate ? startDate : lastMonthStart),
            moment(lastMonthEnd > endDate ? endDate : lastMonthEnd),
        ]
        if (lastMonthStart > endDate || lastMonthEnd < startDate) lastMonth = null
        // 全部
        total = [moment(startDate), moment(today > endDate ? endDate : today)]
    }

    let string = ''
    if (type?.constructor === Array) {
        type.forEach(item => {
            if (item === '1') {
                string = 'source'
            } else if (item === '2') {
                string = 'receiver'
            }
        })
    } else {
        string = type
    }

    switch (string) {
        case 'source':
            startDate = projectData.acquisitionStartDate
            endDate = projectData.acquisitionEndDate
            getValue(startDate, endDate)
            break
        case 'receiver':
            startDate = projectData.receiverStartDate
            endDate = projectData.receiverEndDate
            getValue(startDate, endDate)
            break
        case 'consumable':
            startDate = projectData.firstReportDate
            endDate = projectData.lastReportDate
            getValue(startDate, endDate)
            break
        case 'map':
            const range = getDateRange2(projectData)
            getValue(range.startDate, range.endDate)
            break
        default:
            endDate = projectData.endDate
            startDate = projectData.startDate
            getValue(startDate, endDate)
            break
    }
    return { thisWeek, lastWeek, thisMonth, lastMonth, total }
}

/* 设置日期范围并且过滤 */
export const filterDateRange = obj => {
    let result = {
        [t('ProjectOverview.common.thisWeek')]: obj.thisWeek,
        [t('ProjectOverview.common.lastWeek')]: obj.lastWeek,
        [t('ProjectOverview.common.thisMonth')]: obj.thisMonth,
        [t('ProjectOverview.common.lastMonth')]: obj.lastMonth,
        [t('ProjectOverview.common.total')]: obj.total,
    }
    Object.keys(result).forEach(key => {
        if (!result[key]) delete result[key]
    })
    return result
}

/* 随机 hex 色值 */
export function getRandomColor() {
    var str = '#'
    var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
    for (var i = 0; i < 6; i++) {
        var num = parseInt(Math.random() * 16)
        str += arr[num]
    }
    return str
}

//去除特殊字符~!@#$^-&*()=|{}':;',\[].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？
export const trimSpecial = string => {
    //替换字符串中的所有特殊字符（包含空格）
    if (string !== '') {
        // eslint-disable-next-line no-useless-escape
        const pattern = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g
        string = string.replace(pattern, '')
    }
    return string
}

export const extractCoordinates = geoJSON => {
    const startEndPoints = geoJSON.features.reduce((acc, feature) => {
        if (feature.geometry.type === 'LineString') {
            let [start, end] = feature.geometry.coordinates;
            acc.push([start.slice().reverse(), end.slice().reverse()]);
        }
        // 如果你的 GeoJSON 中包含 MultiLineString，你需要额外处理它  
        // 这里为了简洁，我们假设只处理 LineString  
        return acc;
    }, []);
    return startEndPoints
}

export const barScrollData = data => {
    // 解析日期并找到最早和最晚的日期   三个月以内
    let minDate = null;
    let maxDate = null;
    data.forEach(item => {
        const date = new Date(item.produce_date);
        if (!minDate || date < minDate) {
            minDate = date;
        }
        if (!maxDate || date > maxDate) {
            maxDate = date;
        }
    });
    // 计算日期差异（以天为单位）  
    const diffInDays = (maxDate - minDate) / (1000 * 60 * 60 * 24);
    const dataZoom = [
        {
            type: 'slider',
            start: diffInDays > 90 ? 100 - 90 / diffInDays * 100 : 0, // 如果超过三个月，则默认显示后三个月数据  
            end: 100,
            show: diffInDays > 90, // 如果超过三个月，显示滚动条  
            height: 37,
            bottom: 0,
            // bottom: 7
        },
        // {
        //     type: 'inside',
        //     start: diffInDays > 90 ? 100 - 90 / diffInDays * 100 : 0, // 与 slider 保持一致  
        //     end: 100
        // }
    ]
    return dataZoom
}

export const isBetweenSevenToSeven = () => {
    const now = new Date()
    const hours = now.getHours()

    // 检查当前小时数是否在 7 和 19 之间（包括7和19）
    // 注意：JavaScript的getHours()方法返回的是24小时制的小时数，从0（午夜）到23
    return hours >= 7 && hours < 19
}

// csv个位数时间补零
export const processCSVData = (csvData) => {
    // 假设csvData是一个CSV字符串，每行由逗号分隔  
    // 首先，我们将CSV字符串按行分割  
    const lines = csvData.split('\n');

    // 遍历每一行  
    for (let i = 0; i < lines.length; i++) {
        // 按逗号分割当前行的数据  
        const fields = lines[i].split(',');
        // 注意：这取决于你的CSV数据的具体结构  

        if (i > 0 && fields[1] && /^\d{2}:\d{2}$/.test(fields[1])) {
            fields[1] = `${fields[1]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[2] && /^\d{2}:\d{2}$/.test(fields[2])) {
            fields[2] = `${fields[2]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[3] && /^\d{2}:\d{2}$/.test(fields[3])) {
            fields[3] = `${fields[3]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[4] && /^\d{2}:\d{2}$/.test(fields[4])) {
            fields[4] = `${fields[4]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[6] && /^\d{2}:\d{2}$/.test(fields[6])) {
            fields[6] = `${fields[6]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[8] && /^\d{2}:\d{2}$/.test(fields[8])) {
            fields[8] = `${fields[8]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        if (i > 0 && fields[10] && /^\d{2}:\d{2}$/.test(fields[10])) {
            fields[10] = `${fields[10]}\u200B`; // 注意，如果CSV中有引号包围的值，这里也需要加上引号  
        }

        // 将处理后的字段重新组合成一行  
        lines[i] = fields.join(',');
    }

    // 将处理后的行重新组合成CSV字符串  
    return lines.join('\n');
}

// 定义一个函数，用于删除字符串中的不可见字符  
export const removeInvisibleCharacters = (str) => {
    // 使用正则表达式匹配并替换不可见字符  
    const cleanedString = str?.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'“”‘’]/g, '');
    return cleanedString;
}

// 级联选择器 render 显示Label
export const cascaderShowLabel = (data, text, color) => {
    let result = []
    let colorBox = []

    data?.forEach(dictObj => {
        if (dictObj?.dictValue === text[text?.length - 1]) {
            colorBox.push(dictObj?.listClass)
            const label = getStroage('language') === 'zh' ? dictObj.dictLabel : dictObj.dictLabelEn
            result.push(label)
            for (let i = 0; i < data.length; i++) {
                if (data[i].dictCode === dictObj.parentId) {
                    colorBox.unshift(data[i].listClass)
                    const label = getStroage('language') === 'zh' ? data[i].dictLabel : data[i].dictLabelEn
                    result.unshift(label)
                }
            }
        }
    })
    if (color) {
        return colorBox
    }

    if (result.length === 0) {
        return undefined
    } else {
        return result?.join(' , ')
    }
}

// select选择器 render 显示Label
export const selectShowLabel = (data, text, color) => {
    let result = []
    let colorBox = []

    data?.forEach(item => {
        if (text === item?.dictValue) {
            colorBox.unshift(item.listClass)
            const label = (getStroage('language') === 'zh' ? item.dictLabel : item.dictLabelEn)
            result.unshift(label)
        }
    })

    if (color) {
        return colorBox
    }

    if (result.length === 0) {
        return undefined
    } else {
        return result?.join(' , ')
    }
}

export const isOrdered = (str) => {
    // 使用分号分割字符串，得到包含数字的数组  
    const numbers = str.split(';').map(Number); // 将每个元素转换为数字  

    // 验证数组长度至少为2（至少有两个数字才能判断顺序）  
    if (numbers.length < 2) {
        return true; // 如果数字个数少于2个，直接返回false  
    }

    // 检查是否有重复的数字  
    const uniqueNumbers = new Set(numbers);
    if (uniqueNumbers.size !== numbers.length) {
        return false;
    }

    // 检查是否完全正序  
    let isAscending = true;
    for (let i = 0; i < numbers.length - 1; i++) {
        if (numbers[i] > numbers[i + 1]) {
            isAscending = false;
            break;
        }
    }

    // 如果不是完全正序，检查是否完全倒序  
    if (!isAscending) {
        let isDescending = true;
        for (let i = 0; i < numbers.length - 1; i++) {
            if (numbers[i] < numbers[i + 1]) {
                isDescending = false;
                break;
            }
        }
        return isDescending; // 如果完全倒序，返回true  
    }
    // 如果完全正序，也返回true  
    return isAscending;
}

export const isAscendingArr = (arr) => {
    // 将字符串数组转换为数字数组  
    const nums = arr?.map(Number);

    // 判断是否为正序  
    for (let i = 0; i < nums?.length - 1; i++) {
        if (nums[i] > nums[i + 1]) {
            return false; // 发现逆序，返回false  
        }
    }

    return true; // 所有元素均满足正序，返回true  
}

export const addKeysToNestedArray = (arr, keyPrefix = '', counter = 0) => {
    // 递归函数  
    function recursiveAddKeys(items) {
        return items.map(item => {
            // 生成唯一的key  
            const newKey = `${item?.name}`;

            // 如果item是对象且没有key属性，则添加key属性  
            if (typeof item === 'object' && item !== null && !item.key) {
                // 浅拷贝item对象，避免直接修改原对象  
                const newItem = { ...item };
                newItem.key = newKey;

                // 如果item有children属性，且children是数组，则递归处理children  
                if (Array.isArray(newItem.children)) {
                    newItem.children = recursiveAddKeys(newItem.children, `${newKey}-`);
                }

                return newItem;
            }

            // 如果item不是对象或者已经是叶子节点，直接返回（这里假设非对象不需要key）  
            return item;
        });
    }

    // 调用递归函数处理原始数组  
    return recursiveAddKeys(arr);
}

export const getLevelInTree = (tree, targetId, level = 1) => {
    for (const node of tree) {
        if (node.id === targetId) {
            return level;
        }
        if (node.children) {
            const result = getLevelInTree(node.children, targetId, level + 1);
            if (result !== undefined) {
                return result;
            }
        }
    }
    return undefined; // 如果没有找到目标对象，返回 undefined  
}

export const getResult = (initData) => {
    const result = [];

    // 使用一个 Set 来跟踪已经处理过的日期  
    const processedDates = new Set();

    initData.forEach(item => {
        const formattedDate = item.date; // 或者使用您想要的日期格式  
        const money = parseFloat(item.money);

        // 检查日期是否已经被处理过  
        if (!processedDates.has(formattedDate)) {
            // 创建一个新的对象来存储该日期的信息  
            const dateObj = {
                Date: formattedDate,
                [item.type]: null // 使用一个对象来存储 type 和对应的 money  
            };

            // 将 money 累加到对应的 type 上  
            if (!dateObj[item.type]) {
                dateObj[item.type] = 0;
            }
            dateObj[item.type] += Number(money);

            // 将新创建的对象添加到结果数组中  
            result.push(dateObj);

            // 将日期添加到已处理集合中  
            processedDates.add(formattedDate);
        } else {
            // 如果日期已经被处理过，则找到对应的对象并累加 money  
            const existingDateObj = result.find(obj => obj.Date === formattedDate);
            if (!existingDateObj[item.type]) {
                existingDateObj[item.type] = 0;
            }
            existingDateObj[item.type] += Number(money);
        }
    });
    result.forEach(dateObj => {
        Object.keys(dateObj).forEach(key => {
            if (key !== 'Date') { // 排除 Date 键  
                dateObj[key] = dateObj[key].toFixed(3); // 格式化并转换为字符串（如果需要保留为数值类型则不进行此步）  
            }
        });
    });

    return result
}

// 树形结构数据通过sort字段排序
export const sortTree = (tree) => {
    // 定义一个辅助函数，用于对数组进行排序
    function sortNodes(nodes) {
        if (!Array.isArray(nodes)) return;

        nodes.sort((a, b) => a.sort - b.sort);

        // 递归地对每个子节点进行排序
        nodes.forEach(node => {
            if (node.children && Array.isArray(node.children)) {
                sortNodes(node.children);
            }
        });
    }

    // 对根节点（或顶层节点）进行排序
    if (Array.isArray(tree)) {
        sortNodes(tree);
    } else if (tree.children && Array.isArray(tree.children)) {
        // 如果 tree 是一个对象且包含 children 字段，则对其 children 进行排序
        sortNodes(tree.children);
    }

    return tree;
}

export const groupByDate = (data) => {
    const grouped = {};

    data.forEach(item => {
        const date = item.produce_date;
        if (!grouped[date]) {
            grouped[date] = [];
        }
        grouped[date].push(item);
    });

    return grouped;
}

// 保留三位小数
export const formatNumber = (value) => {
    // 检查值是否为null或空字符串
    if (value == null || value === '') {
        return ''
    }

    // 尝试将值转换为数字
    const number = Number(value)

    // 如果转换失败（例如，如果值是一个非数字字符串），则抛出错误
    if (isNaN(number)) {
        return ''
    }

    return number.toLocaleString()
}

export const getCookie = name => {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
}

// 计算开始时间到结束时间的小时数
export const calculateHoursDifference = (startTime, endTime) => {
    // 将时间字符串解析为小时和分钟
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);

    // 计算总分钟数差异
    const startTotalMinutes = startHour * 60 + startMinute;
    const endTotalMinutes = endHour * 60 + endMinute;

    // 计算分钟数差异
    const differenceInMinutes = endTotalMinutes - startTotalMinutes;

    // 将分钟数差异转换为小时数
    const differenceInHours = differenceInMinutes / 60;

    return differenceInHours?.toFixed(2);
}

// 将格式转为echarts联动图表格式
export const transformMultipleData = (data) => {
    // 初始化结果对象
    const result = {};

    // 收集所有唯一日期（自动排序）
    const allDates = [...new Set(data.map(item => item.Date))].sort();

    // 收集所有字段名（排除Date后保留原始顺序）
    const allFields = Array.from(
        new Set(data.flatMap(item => Object.keys(item)))
    ).filter(field => field !== 'Date' && field !== 'Total');

    // 强制Date字段作为第一个维度
    result['Date'] = allDates;

    // 处理其他字段
    allFields.forEach(key => {
        const fieldData = [];

        allDates.forEach(date => {
            const item = data.find(d => d.Date === date);
            fieldData.push(
                item && item.hasOwnProperty(key)
                    ? (item[key] === 0 ? null : item[key])
                    : null
            );
        });

        result[key] = fieldData;
    });

    // 转换为二维数组格式，确保Date在第一列
    const formattedResult = [
        ['Date', ...allDates],  // 第一行：日期标题+日期数据
        ...allFields.map(key => [key, ...result[key]])  // 其他字段行
    ];

    return formattedResult;
}

// 周末数据继承函数
export const propagateWeekendData = (data) => {
    return data.map((item, index) => {
        // 使用toLocaleString强制转换为中国时区
        const chinaDateStr = new Date(item.produceDate).toLocaleString('en-US', {
            timeZone: 'Asia/Shanghai'
        });

        // 将转换后的字符串重新解析为Date对象
        const chinaDate = new Date(chinaDateStr);

        // 获取中国时区的星期几
        const weekday = chinaDate.getDay();
        if (index === 0 && weekday !== 6) {
            const sourceFields = {
                operationSummary: item.operationSummary,
                challenges: item.challenges,
                potentialImpacts: item.potentialImpacts,
                plannedProspectAreaFilePath: item.plannedProspectAreaFilePath,
                prospectAreaFilePath: item.prospectAreaFilePath,
                weatherFilePath: item.weatherFilePath,
                plannedProspectArea: item.plannedProspectArea,
                prospectArea: item.prospectArea,
                weather: item.weather,
                sopKpi: item.sopKpi,
                inspectionKpi: item.inspectionKpi
            };

            let targetDay = weekday;

            for (let i = index + 1; i < data.length; i++) {
                // 使用toLocaleString强制转换为中国时区
                const chinaDateCurrent = new Date(data[i].produceDate).toLocaleString('en-US', {
                    timeZone: 'Asia/Shanghai'
                });
                const chinaDatePrev = new Date(data[i - 1].produceDate).toLocaleString('en-US', {
                    timeZone: 'Asia/Shanghai'
                });
                const currentDate = new Date(chinaDateCurrent);
                const currentDay = currentDate.getDay();
                const prevDate = new Date(chinaDatePrev);
                const prevDay = prevDate.getDay();

                if (currentDay === 6) {
                    // 遇到新的周六，结束当前周期
                    break;
                }

                if ((currentDay === 0 && prevDay === 6) || // 周日
                    (currentDay === prevDay + 1 && prevDay !== 6) || // 连续工作日
                    (currentDay === 1 && prevDay === 0)) { // 周一
                    data[i] = {
                        ...data[i],
                        ...sourceFields
                    };
                } else if (currentDay === targetDay) {
                    // 遇到周五
                    data[i] = {
                        ...data[i],
                        ...sourceFields
                    };
                    break; // 终止复制
                } else {
                    // 不连续且不是目标周五
                    break;
                }
            }
        }

        if (weekday === 6) { // 周六
            const sourceFields = {
                operationSummary: item.operationSummary,
                challenges: item.challenges,
                potentialImpacts: item.potentialImpacts,
                plannedProspectAreaFilePath: item.plannedProspectAreaFilePath,
                prospectAreaFilePath: item.prospectAreaFilePath,
                weatherFilePath: item.weatherFilePath,
                plannedProspectArea: item.plannedProspectArea,
                prospectArea: item.prospectArea,
                weather: item.weather,
                sopKpi: item.sopKpi,
                inspectionKpi: item.inspectionKpi
            };
            let targetDay = 5; // 周五

            for (let i = index + 1; i < data.length; i++) {
                // 使用toLocaleString强制转换为中国时区
                const chinaDateCurrent = new Date(data[i].produceDate).toLocaleString('en-US', {
                    timeZone: 'Asia/Shanghai'
                });
                const chinaDatePrev = new Date(data[i - 1].produceDate).toLocaleString('en-US', {
                    timeZone: 'Asia/Shanghai'
                });
                const currentDate = new Date(chinaDateCurrent);
                const currentDay = currentDate.getDay();
                const prevDate = new Date(chinaDatePrev);
                const prevDay = prevDate.getDay();

                if (currentDay === 6) {
                    // 遇到新的周六，结束当前周期
                    break;
                }

                if ((currentDay === 0 && prevDay === 6) || // 周日
                    (currentDay === prevDay + 1 && prevDay !== 6) || // 连续工作日
                    (currentDay === 1 && prevDay === 0)) { // 周一
                    data[i] = {
                        ...data[i],
                        ...sourceFields
                    };
                } else if (currentDay === targetDay) {
                    // 遇到周五
                    data[i] = {
                        ...data[i],
                        ...sourceFields
                    };
                    break; // 终止复制
                } else {
                    // 不连续且不是目标周五
                    break;
                }
            }
        }

        return item;
    });
};

// 安全除法计算函数
export const safeDivision = (dividend, divisor) => {
    // 检查除数是否为0、非数值或无效值
    if (divisor === 0 || !isFinite(divisor) || isNaN(divisor)) {
        return 0
    }

    const result = dividend / divisor

    // 使用isFinite检查结果是否为有限数值
    return isFinite(result) ? result : 0
}

export function clearUrlTicket() {
    // 1. 获取当前 URL 的解析对象（方便操作参数）
    const urlObj = new URL(window.location.href)

    // 2. 删除 ticket 参数（核心步骤：清空 ticket 本质就是移除该参数）
    urlObj.searchParams.delete('ticket')

    // 3. 生成移除 ticket 后的新 URL
    const newUrl = urlObj.href

    // 4. 替换当前 URL 记录（不刷新页面）—— 改动：history → window.history
    window.history.replaceState(null, document.title, newUrl) // 这里加上 window.
}
